<user-resources-list [loaded]="loaded"
                     [resourcePermissionType]="resourcePermissionType"
                     [data]="data"
                     title="Link Types"
                     i18n-title="@@linkTypes">
</user-resources-list>
